import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';

import Global from '../../../../../store/global-selectors';
import { openLtlWizard } from '../../../../../store/ltl/ltl.actions';
import { ltlShipmentsGridMessages } from '../messages';

const BOOKED_STATUS = 'Booked';

const BolNumber = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const dispatch = useDispatch();
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  const handleClick = useCallback(
    (e: React.MouseEvent | React.FormEvent) => {
      (e.target as HTMLElement).blur();
      dispatch(openLtlWizard({ mode: 'view-booked', freightShipmentId }));
    },
    [dispatch, freightShipmentId],
  );

  const bolNumber = shipment?.bolNumber ?? '';

  if (!bolNumber || shipment?.status !== BOOKED_STATUS) {
    return <>{bolNumber}</>;
  }

  return (
    <Button onClick={handleClick} theme='link'>
      {bolNumber}
    </Button>
  );
};

export const bolNumber = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.bolNumber,
  name: <FormattedMessage {...ltlShipmentsGridMessages.bolNumber} />,
  id: 'bolNumber',
  width: 130,
  minWidth: 70,
  index: 0,
  render: (data: { id: string }) => <BolNumber freightShipmentId={data.id} />,
};
